import Vue from 'vue'

import {fn_getValueByKey, fn_getNameWithMap} from '../utilities/utilityOperators'

import {
  REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ,
  REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_OBJ,
  REF_MATERNAL_FETAL_FORM_GYNE_CONDITIONS_OBJ,
  REF_MATERNAL_FETAL_FORM_GYNE_OBJ,
  REF_MATERNAL_FETAL_FORM_PREGNANCY_TYPE_OBJ,
  REF_MATERNAL_FETAL_FORM_DELIVERY_OBJ,
  getMapFn,
  REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY_OBJ,
  REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY_CONDITIONS_OBJ,
  REF_MATERNAL_FETAL_FORM_CONCOMITANT_PROCEDURES_OBJ,
  REF_MATERNAL_FETAL_FORM_PRIMARY_REPEAT_OBJ,
  REF_MATERNAL_FETAL_FORM_INCISION_OBJ,
  REF_MATERNAL_FETAL_FORM_INDICATIONS_CS_OBJ,
  REF_MATERNAL_FETAL_FORM_ORGAN_OBJ,
  REF_MATERNAL_FETAL_FORM_ORGAN_PROCEDURES_OBJ,
  REF_MATERNAL_GTD_DIAGNOSIS_OBJ,
  REF_MATERNAL_GTD_COMPLICATIONS_OBJ,
  REF_MATERNAL_GTD_OTHER_SURGICAL_INTERVENTION_OBJ,
  REF_MATERNAL_FETAL_FORM_MOTHER_CONDITION_OBJ,
  REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_OBJ,
  REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_ANTECEDENTS_OBJ,
  REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_DEATH_OBJ,
  REF_MATERNAL_MORTALITY_IMMEDIATE_CAUSE_OBJ,
  REF_MATERNAL_MORTALITY_TIMING_OBJ,
  REF_MATERNAL_MORTALITY_SPECIFIC_OBJ,
  REF_MATERNAL_GTD_CONDITIONS_OBJ,
  REF_MATERNAL_GTD_MEDICAL_SURGICAL_OBJ,
  REF_MATERNAL_FETAL_FORM_MORBIDITIES_OBJ,
  REF_MATERNAL_FETAL_FORM_MORBIDITIES_CONDITIONS_OBJ,
  REF_MATERNAL_FETAL_FORM_NEONATAL_CONDITIONS_OBJ,
  REF_PROCEDURE_TYPES_OBJ,
  REF_PROCEDURE_TYPES_UTERUS_OBJ,
  REF_PROCEDURE_TYPES_MIS_OBJ,
  REF_PROCEDURE_TYPES_OTHERS_OBJ,
  REF_AOG_RANGES_OBJ,
  REF_MATERNAL_FETAL_FORM_INDICATION_FORCEPS_OBJ,
  REF_MATERNAL_FETAL_FORM_INDICATION_VACUUM_OBJ,
  REF_MALIGNANT_STAGE_TYPES_OBJ,
  REF_NONMALIGNANT_STAGE_TYPES_OBJ,
  REF_ABORTION_TYPE_OBJ,
  REF_ECTOPIC_TYPE_OBJ,
  REF_MOLAR_TYPE_OBJ,
  REF_MATERNAL_FETAL_FORM_OBORGAN_OBJ,
  REF_MATERNAL_FETAL_FORM_ORGAN_OBPROCEDURES_OBJ,
} from '../store/modules/referencedata2'



/*const fn_getValueWithMap = (map) => (val) => {
  return map[val] !== undefined ? map[val] : 'N/A!'
}*/



const fn_nullFormat = (nullValue) => (value) => value === "0%" || value === 0 ? nullValue : value;

Vue.filter ('tableNullFormat', fn_nullFormat("-"));

Vue.filter('getValueByKey', fn_getValueByKey);

Vue.filter('decodeProcedureTypes', function (val, categoryId) {
  if (categoryId === 1)
    return fn_getNameWithMap(getMapFn(REF_PROCEDURE_TYPES_UTERUS_OBJ))(val);
  else if (categoryId === 7)
    return fn_getNameWithMap(getMapFn(REF_PROCEDURE_TYPES_MIS_OBJ))(val);
  else if (categoryId === 8)
    return fn_getNameWithMap(getMapFn(REF_PROCEDURE_TYPES_OTHERS_OBJ))(val);
  else
    return fn_getNameWithMap(getMapFn(REF_PROCEDURE_TYPES_OBJ))(val);
});

Vue.filter('decodeGyneStageTypes', function (val, categoryId) {
  if (categoryId === 24 || categoryId === 23 || categoryId === 18 || categoryId === 17 || categoryId === 16 || categoryId === 15 || categoryId === 14 || categoryId === 201)
    return fn_getNameWithMap(getMapFn(REF_MALIGNANT_STAGE_TYPES_OBJ))(val);
  else
    return fn_getNameWithMap(getMapFn(REF_NONMALIGNANT_STAGE_TYPES_OBJ))(val);
});

Vue.filter('decodeAOGRange', fn_getNameWithMap(  getMapFn(REF_AOG_RANGES_OBJ)));

Vue.filter('decodeMedicalHistoryCategory', fn_getNameWithMap(  getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_OBJ)));
Vue.filter('decodeMedicalHistoryCondition', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ)));

Vue.filter('decodeObstetricHistoryCategory', fn_getNameWithMap(  getMapFn(REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY_OBJ)));
Vue.filter('decodeObstetricHistoryCondition', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_OBSTETRIC_HISTORY_CONDITIONS_OBJ)));

Vue.filter('decodePregnancyType', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_PREGNANCY_TYPE_OBJ)));
Vue.filter('decodeAbortionType', fn_getNameWithMap(getMapFn(REF_ABORTION_TYPE_OBJ)));
Vue.filter('decodeEctopicType', fn_getNameWithMap(getMapFn(REF_ECTOPIC_TYPE_OBJ)));
Vue.filter('decodeMolarType', fn_getNameWithMap(getMapFn(REF_MOLAR_TYPE_OBJ)));

Vue.filter('decodeDeliveryManner', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_DELIVERY_OBJ)));
Vue.filter('decodePrimaryRepeat', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_PRIMARY_REPEAT_OBJ)));
Vue.filter('decodeIncision', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_INCISION_OBJ)));
Vue.filter('decodeIndicationCs', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_INDICATIONS_CS_OBJ)));
Vue.filter('decodeIndicationForceps', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_INDICATION_FORCEPS_OBJ)));
Vue.filter('decodeIndicationVacuum', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_INDICATION_VACUUM_OBJ)));

Vue.filter('decodeConcomittantProcedures', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_CONCOMITANT_PROCEDURES_OBJ)));
Vue.filter('decodeMorbidities', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_MORBIDITIES_OBJ)));
Vue.filter('decodeMorbidityCondition', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_MORBIDITIES_CONDITIONS_OBJ)));
Vue.filter('decodeNeonatalStatus', fn_getNameWithMap( getMapFn(REF_MATERNAL_FETAL_FORM_NEONATAL_CONDITIONS_OBJ)));

Vue.filter('decodeGyneCategory', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_GYNE_OBJ)));
Vue.filter('decodeGyneCondition', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_GYNE_CONDITIONS_OBJ)));
Vue.filter('decodeGyneOrgan', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_ORGAN_OBJ)));
Vue.filter('decodeGyneOrganCondition', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_ORGAN_PROCEDURES_OBJ)));
Vue.filter('decodeGtdDiagnosis', fn_getNameWithMap(getMapFn(REF_MATERNAL_GTD_DIAGNOSIS_OBJ)));
Vue.filter('decodeGtdComplication', fn_getNameWithMap(getMapFn(REF_MATERNAL_GTD_COMPLICATIONS_OBJ)));
Vue.filter('decodeSurgicalIntervention', fn_getNameWithMap(getMapFn(REF_MATERNAL_GTD_OTHER_SURGICAL_INTERVENTION_OBJ)));
Vue.filter('decodeGtdCondition', fn_getNameWithMap(getMapFn(REF_MATERNAL_GTD_CONDITIONS_OBJ)));
Vue.filter('decodeMedicalSurgical', fn_getNameWithMap(getMapFn(REF_MATERNAL_GTD_MEDICAL_SURGICAL_OBJ)));

Vue.filter('decodeMotherCondition', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_MOTHER_CONDITION_OBJ)));
Vue.filter('decodeAntecedent', fn_getNameWithMap(getMapFn(REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_OBJ)));
Vue.filter('decodeAntecedentType', fn_getNameWithMap(getMapFn(REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_ANTECEDENTS_OBJ)));
Vue.filter('decodeUnderlyingCause', fn_getNameWithMap(getMapFn(REF_MATERNAL_MORTALITY_ATECEDENT_CAUSE_DEATH_OBJ)));
Vue.filter('decodeImmediateCause', fn_getNameWithMap(getMapFn(REF_MATERNAL_MORTALITY_IMMEDIATE_CAUSE_OBJ)));
Vue.filter('decodeTiming', fn_getNameWithMap(getMapFn(REF_MATERNAL_MORTALITY_TIMING_OBJ)));
Vue.filter('decodeSpecific', fn_getNameWithMap(getMapFn(REF_MATERNAL_MORTALITY_SPECIFIC_OBJ)));

/** not used */
Vue.filter('decodeGyneService', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ)));
Vue.filter('decodeGyneLaterality', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ)));
Vue.filter('decodeGyneElectiveEmergency', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ)));
Vue.filter('decodeGyneApproach', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_MEDICAL_HISTORY_CONDITIONS_OBJ)));

Vue.filter('decodeProcedureCategory', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_ORGAN_OBJ)));
Vue.filter('decodeProcedureConditions', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_ORGAN_PROCEDURES_OBJ )));

Vue.filter('decodeOBProcedureCategory', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_OBORGAN_OBJ)));
Vue.filter('decodeOBProcedureConditions', fn_getNameWithMap(getMapFn(REF_MATERNAL_FETAL_FORM_ORGAN_OBPROCEDURES_OBJ )));





